import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import { TransitionGroup } from 'react-transition-group';

const FirstChild = ({ children }) => Children.toArray(children)[0] || null;

class Portal extends Component {
  portalElement = null; // eslint-disable-line react/sort-comp

  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  componentDidMount() {
    const node = document.createElement('div');
    if (document.body) {
      document.body.appendChild(node);
      this.portalElement = node;

      /* Mounting a modal in a portal has side effects (e.g. applying scroll / focus locks).
         Because the unmounting of these portals happens asynchronously, we wait for a moment before mounting new
         portals to avoid race conditions in unmount handlers. */
      setTimeout(() => this.componentDidUpdate(), 1);
    }
  }

  componentDidUpdate() {
    const { children } = this.props;

    render(this.renderChildren(children), this.portalElement);
  }

  componentWillUnmount() {
    /* re-renders an empty react tree into the portal element so that any mounted components get cleaned up and have a
       chance to complete their lifecycle before the portal is removed from the dom entirely. */
    render(this.renderChildren(), this.portalElement, () => {
      /* Wait five seconds before removing the portal element to allow time for transitions to complete before the dom
         is cleaned up. */
      setTimeout(() => {
        // prevent undefined errors.
        if (!document.body || !this.portalElement) {
          return;
        }

        document.body.removeChild(this.portalElement);
      }, 5000);
    });
  }

  renderChildren = children => <TransitionGroup component={FirstChild}>{children}</TransitionGroup>;

  render() {
    return null;
  }
}

export default function PortalWrapper(props) {
  return <Portal {...props} />;
}
